import { render, staticRenderFns } from "./SeatItem.vue?vue&type=template&id=d9234d6a&"
import script from "./SeatItem.vue?vue&type=script&lang=js&"
export * from "./SeatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports